var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 161,
    viewBox: "0 0 170 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.672 42.364C169.931 42.5526 170.037 42.804 169.99 43.1182L166.973 61.2193C166.934 61.4471 166.808 61.6239 166.596 61.7496C166.486 61.8124 166.365 61.8439 166.231 61.8439C166.145 61.8439 166.05 61.8242 165.948 61.7849L160.61 59.6048L157.758 63.0812C157.616 63.2619 157.424 63.3523 157.18 63.3523C157.078 63.3523 156.992 63.3366 156.921 63.3051C156.772 63.2501 156.652 63.1578 156.562 63.0282C156.471 62.8986 156.426 62.7552 156.426 62.5981V58.4853L166.608 46.0054L154.01 56.9061L149.356 54.997C149.065 54.887 148.908 54.671 148.884 54.3489C148.868 54.0346 148.994 53.8029 149.261 53.6536L168.871 42.3404C168.989 42.2697 169.114 42.2344 169.248 42.2344C169.405 42.2344 169.546 42.2776 169.672 42.364Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00235144 96.3035C29.3874 117.913 101.875 141.661 156.747 63.7788C103.355 135.508 30.004 115.349 0.00235144 96.3035Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1179,
    height: 21.1179,
    fill: "white",
    transform: "translate(148.883 42.2344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.9345ad99ab754778b872e6628c316c89.svg";
export { ForwardRef as ReactComponent };